import { CardOnFileActions, CardOnFileActionsProps } from './actions';

export type CardOnFileActionsStripeProps = CardOnFileActionsProps;

export const CardOnFileActionsStripe = (props: CardOnFileActionsStripeProps) => {
  return <CardOnFileActions {...props} />;
};
